module.exports = __webpack_public_path__ + "img/bird.f41c394b.png";